module.exports = __webpack_public_path__ + "img/imagem-detalhada-palmeiras-03.2a55a1f4.png";